<template>
  <v-container >
    <v-row>
        <v-col>
          <v-row justify="start">
            <div class="menu-title ml-10">
              Lunch & Dinner
            </div>
          </v-row>
          <v-row justify="center">
              <tcard  v-for="(menu, index) in lunchDinner" :key="index"   
                      :menu="menu"  
              ></tcard>
          </v-row>
          <v-row justify="start">
          <div class="menu-title ml-4">
            Groups & Family Meals
          </div>
        </v-row>
          <v-row justify="center">
              <tcard  v-for="(menu, index) in familyMeals" :key="index"   
                      :menu="menu"  
              ></tcard>
          </v-row>
          <v-row justify="start">
          <div class="menu-title ml-4 mt-6">
            Sandwiches
          </div>
        </v-row>
          <v-row justify="center">
              <tcard  v-for="(menu, index) in sandwitchs" :key="index"   
                      :menu="menu"  
              ></tcard>
          </v-row>
          <v-row justify="start">
          <div class="menu-title ml-4 mt-6">
            Vegetarian Dishes
          </div>
        </v-row>
          <v-row justify="center">
              <tcard  v-for="(menu, index) in vegetarianDishes" :key="index"   
                      :menu="menu"  
              ></tcard>
          </v-row>
          <v-row justify="start">
          <div class="menu-title ml-4 mt-6">
            Beverages
          </div>
        </v-row>
          <v-row justify="center">
              <bCard  v-for="(menu, index) in beverages" :key="index"   
                      :menu="menu"  
              ></bCard>
          </v-row>
        <v-row justify="start">
          <div class="menu-title ml-4 mt-10">
            Appetizers & Sides
          </div>
        </v-row>
          <v-col>
            <v-row justify="center">
                <aCard  v-for="(menu, index) in appetizers" :key="index"   
                        :menu="menu"  
                ></aCard>
            </v-row>
          </v-col>
        </v-col>
    </v-row>
      
 </v-container>
</template>

<script>
   import tcard  from "@/components/tcard";
   import bCard  from "@/components/bCard";
   import aCard  from "@/components/aCard";
  import {mapActions } from "vuex";
export default {
  
  name: "Home",
  components: {
    tcard,
    bCard,
    aCard,
  },
  data() {
    return {
      images: [],
      items: [],
      lunchDinner: [],
      familyMeals: [],
      sandwitchs: [],
      vegetarianDishes: [],
      beverages: [],
      appetizers: [],
    }
  }, 
  methods: {
    ...mapActions(['getAllText']),
    find() {
      this.getAllText().then(result =>{
        result.data.forEach(element => {
          switch(element.catagory) {
            case "Lunch & Dinner" :
              this.lunchDinner.push(element)
              break;
            case "Groups & Family Meals":
              this.familyMeals.push(element)
              break;
            case "Sandwiches":
              this.sandwitchs.push(element)
              break;
            case "Vegetarian Dishes":
              this.vegetarianDishes.push(element)
              break;
            case "Beverages" :
              this.beverages.push(element)
              break;
            case "Appetizers & Sides":
              this.appetizers.push(element)
              break
            default: 
              console.log("something went wrong.. wrong menu catagory")
          }
          
        });

      }) 
    }
  }, 
  computed: {
    src: function() {
        if(process.env.NODE_ENV === 'production') {
            return "/api/images/image?filename="
        } else {
            return "http://localhost:5000/api/images/image?filename="
        }
    }
  },
  mounted() {
    this.find();
  }
}
</script>

<style>
  .home-page {
    width: 100%;
    height: 100%;
  }
  .menu-title {
    color: rgba(153, 78, 7, 0.787);
    font-size: 32px;
    font-style: italic;
    font-family: cursive;
   
  }
</style>